import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  empresa: null,
  centroCusto: [],
  produto: [],
  projeto: [],
  responsavel: [],
  grupo: [],
  fornecedor: [],
  solicitante: [],
  tipoProduto: null,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
